import { render, staticRenderFns } from "./TypeDrink.vue?vue&type=template&id=5ff35dd1&scoped=true&"
import script from "./TypeDrink.vue?vue&type=script&lang=js&"
export * from "./TypeDrink.vue?vue&type=script&lang=js&"
import style0 from "./TypeDrink.vue?vue&type=style&index=0&id=5ff35dd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff35dd1",
  null
  
)

export default component.exports